import React from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import get from "lodash/get";
import { string } from "prop-types";

import "./gdprPolicy.m.css";

const GdprPolicy = ({ domainLink }) => {
  // Start of UUID Generate
  if (typeof window !== "undefined") {
    const uuidCookies = new Cookies();

    if (!uuidCookies.get("uuid_v2")) {
      const navigatorInfo = window.navigator;
      const screenInfo = window.screen;
      const currentDate = new Date();
      let uid = "h";
      uid += navigatorInfo.mimeTypes.length;
      uid += navigatorInfo.userAgent.replace(/\D+/g, "");
      uid += navigatorInfo.plugins.length;
      uid += screenInfo.height || "";
      uid += screenInfo.width || "";
      uid += screenInfo.pixelDepth || "";
      uid += screenInfo.colorDepth || "";
      uid += screenInfo.top || "";
      uid += currentDate.getMonth() || "";
      uid += currentDate.getDate() || "";
      uid += currentDate.getHours() || "";

      uuidCookies.set("uuid_v2", uid, { path: "/", maxAge: 60 * 60 * 24 * 365 });
    }
  }

  if (getCookieConsentValue()) {
    const cookies = new Cookies();
    cookies.set("CookieConsent", true, { path: "/", maxAge: 60 * 60 * 24 * 365 });
  }
  return (
    <div>
      <CookieConsent
        location="bottom"
        buttonText="ঠিক আছে"
        containerClasses="gdpr-wrapper"
        style={{
          background: "#000000",
          fontSize: "14px",
          padding: "8px",
          fontFamily: "Kiron",
          display: "grid",
          gridAutoFlow: "column",
          justifyContent: "center",
        }}
        buttonWrapperClasses="ok-button-link"
        buttonStyle={{
          background: "#DAA520",
          color: "#fff",
          fontSize: "14px",
          borderRadius: "3px",
          padding: "3px 8px",
          margin: "0 0 0 12px",
        }}
        contentStyle={{ margin: "auto" }}
      >
        এই ওয়েবসাইট ব্যবহার করার মধ্য দিয়ে আপনি আমাদের{" "}
        <a
          href={`${domainLink}/privacy`}
          rel="noreferrer"
          target="_blank"
          style={{ textDecoration: "underline", color: "#fff" }}
        >
          গোপনীয়তা নীতি
        </a>{" "}
        তে সম্মতি দিয়েছেন
      </CookieConsent>
    </div>
  );
};

GdprPolicy.propTypes = {
  domainLink: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  domainLink: get(state, ["qt", "currentHostUrl"], {}),
});

export default connect(mapStateToProps)(GdprPolicy);
